/**
 * 桌面图库页布局常量：与 Tailwind `w-72`（18rem）对齐。
 * 外层轨道用显式宽度做 CSS transition，避免动画 flex-basis 时与子节点最小宽度互相拉扯。
 */
export const LIBRARY_MANAGEMENT_RAIL_WIDTH_REM = 18 as const

export const LIBRARY_MANAGEMENT_RAIL_WIDTH_CSS = `${LIBRARY_MANAGEMENT_RAIL_WIDTH_REM}rem`
